<template>
  <div class="eventComp_mode_10 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        :expandKey="expandKey"
        :isExpandAll="isExpandAll"
        :competitorType="competitorType"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用：多人||团体模式   游泳 团体（名单和成绩） || 田径 团体（名单和成绩）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_10',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_10 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_10',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 34.7,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      isExpandAll: false, //只要需要expand属性默认都是展开，这个只是控制显示的高度, 控制整个表格是否显示展开行
      currExpandMode: null,
      expandModeNameArr: [
        // 这里目前只是【本场数据】团体模式
        // 不同的小项展开行中的每一行会有区别，以下情况：
        // 出场名单：游泳默认是[运动员] 田径默认是[号码+运动员]
        // 本场数据：默认是 游泳的[棒+运动员+各个成绩]
        {
          // 出场名单：游泳默认是[运动员] 田径默认是[号码+运动员]
          modeName: '',
          defaultInsertCustomColuIndex: 0,
          sportsIdArr: ['ALP'],
        },
        {
          // 出场名单：游泳默认是[运动员] 田径默认是[号码+运动员]
          modeName: '',
          defaultInsertCustomColuIndex: 1,
          sportsIdArr: [
            'SKN',
            'NCB',
            'SJP',
            'LUG',
            'BOB',
            'SWM',
            'DIV',
            'TKW',
            'STK',
            'SSK',
            'CCS',
            'BTH',
            'SMT',
            'FRS',
            'ATW',
          ],
        },
        {
          // 本场数据(田径 男子和女子 20公里竞走团体 || 半马团体 || 马拉松竞走混合接力)： numPlayerPersonResultRank [号码+运动员+个人成绩+个人名次]
          modeName: 'numPlayerPersonResultRank',
          defaultInsertCustomColuIndex: 1,
          eventIdArr: [
            'ATHM20KMWALKTEAM------------------',
            'ATHMHMARATHOTEAM------------------',
            'ATHW20KMWALKTEAM------------------',
            'ATHWHMARATHOTEAM------------------',
            'ATHX42KWALKT----------------------',
          ],
          sportsIdArr: ['ATH'],
          isTabType: 'localData',
        },
        {
          // 本场数据(田径 男子和女子 20公里竞走团体 || 半马团体 || 马拉松竞走混合接力)： numPlayerPersonResultRank [号码+运动员+个人成绩+个人名次]
          modeName: 'expand_default',
          defaultInsertCustomColuIndex: 0,
          sportsIdArr: ['SBD'],
          isTabType: 'localData',
          resultKey: 'result_single',
        },
        {
          // 本场数据(田径 男子和女子和混合 4x100 || 4x400)： numPlayerPersonResultRank [号码+运动员+个人成绩+个人名次]
          modeName: 'numPlayerPersonResultRank',
          defaultInsertCustomColuIndex: 1,
          eventIdArr: [
            'ATHM4X100M------------------------',
            'ATHM4X400M------------------------',
            'ATHW4X100M------------------------',
            'ATHW4X400M------------------------',
            'ATHX4X400M------------------------',
          ],
          sportsIdArr: ['ATH'],
          isTabType: 'localData',
        },
        {
          // 本场数据(射击 单人团体)
          modeName: 'onlyPlayerInfors',
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          sportsIdArr: ['SHO'],
          isTabType: 'localData',
        },
        {
          // 本场数据(跳水；男子团体和女子团体的本场数据与其他的本场数据不同)
          modeName: 'expandT_rowPlayers',
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          // eventIdArr: [
          //   'DIVMTEAM--------------------------',
          //   'DIVWTEAM--------------------------',
          // ],

          variableColWidthVw: 42,
          sportsIdArr: ['SBD', 'DIV', 'FRS'],
          isTabType: 'localData',
          competitorTypeArr: ['T'],
        },
        {
          // 本场数据(跳水|单板滑雪|自由式滑雪)
          modeName: 'expand_default', //默认的本场数据
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          variableColWidthVw: 41.6,
          sportsIdArr: ['LUG', 'DIV', 'FRS'],
          isTabType: 'localData',
          competitorTypeArr: ['A', 'D'],
        },
        {
          // 本场数据(跳水|单板滑雪|自由式滑雪)
          modeName: 'expand_default', //默认的本场数据
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          variableColWidthVw: 41.6,
          sportsIdArr: ['FRS'],
          competitorTypeArr: ['A'],
          isTabType: 'localData',
          resultKey: 'result_single',
        },
        {
          // 本场数据(跳水|单板滑雪|自由式滑雪)
          modeName: 'expand_default', //默认的本场数据
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          variableColWidthVw: 41.6,
          eventIdArr: [
            'FRSMSX----------------------------',
            'FRSWSX----------------------------',
          ],
          sportsIdArr: ['FRS'],
          competitorTypeArr: ['A'],
          isTabType: 'localData',
        },
        {
          // 本场数据(体操；男子团体和女子团体的 团体成绩)
          modeName: '',
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          variableColWidthVw: 25,
          sportsIdArr: ['BOB', 'GAR'],
          isTabType: 'teamResult',
          resultKey: 'result_team',
        },
        {
          // 团体成绩(射箭 男子和女子个人排名赛)： numPlayerPersonResultRank [号码+运动员]
          modeName: 'numPlayerPersonResultRank',
          defaultInsertCustomColuIndex: 1,
          eventIdArr: [
            'ARCMINDIVID-----------------------',
            'ARCWINDIVID-----------------------',
          ],
          sportsIdArr: ['ARC'],
          isTabType: 'teamResult',
          resultKey: 'result_team',
        },
      ],
    }
  },
  beforeCreate() {},
  // created() {
  //   this.init()
  // },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        // this.computedModeData({})
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          let flag = false
          this.expandModeNameArr.forEach((modeItem) => {
            // eventIdArr 和 competitorTypeArr 目前只能二选一
            if (modeItem.eventIdArr) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.eventIdArr.includes(this.currSportsDetail.eventId)
              ) {
                flag = true
                this.currExpandMode = modeItem
              }
            } else if (modeItem.competitorTypeArr) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.competitorTypeArr.includes(this.competitorType)
              ) {
                flag = true
                this.currExpandMode = modeItem
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                !flag
              ) {
                // if(modeItem.competitorTypeArr)
                this.currExpandMode = modeItem
              }
            }
          })
        }
        console.debug(
          'mode_10 currExpandMode:',
          this.currExpandMode,
          this.datas
        )

        this.computedModeData(
          JSON.parse(
            JSON.stringify(
              this.currExpandMode && this.currExpandMode.resultKey
                ? this.datas[this.currExpandMode.resultKey]
                : this.datas
            )
          )
        )
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
      if (data && data.eventName === 'isTableAllExpandEvent') {
        this.tableData.forEach((rowData) => {
          rowData.isShowChild = data.data
        })
        this.isExpandAll = data.data
      }
      if (data && data.eventName === 'clickItemRowArrowEvent') {
        let isExpandAll = true
        // 有一个是关闭的，全部就是【关闭】状态
        this.tableData.forEach((rowData) => {
          if (!rowData.isShowChild) {
            isExpandAll = false
          }
        })
        this.isExpandAll = isExpandAll
      }
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug(
        'mode_10 computedModeData:',
        data,
        this.currExpandMode,
        this.tabType
      )
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head
        let defaultInsertCustomColuIndex = this.currExpandMode
          ? this.currExpandMode.defaultInsertCustomColuIndex
          : 1 //自定义的表头列插入在第几个后面（有的展开的运动员是在第二列，有的是第三列，所以需要判断；大多数都是第三列，所以默认为在0、1之后插入，也就是第三列）

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length < 2) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        headColumns.push({
          colKey: 'arrowIcon',
          colTitle: '',
        })
        headColumns.push({
          colKey: 'isExpand',
          colTitle: '',
        })

        const otherColumns = headColumns

        let tableCellDefaultWidthVw = this.currExpandMode
          .tableCellDefaultWidthVw
          ? this.currExpandMode.tableCellDefaultWidthVw
          : this.tableCellDefaultWidthVw

        let variableColWidthVw = this.currExpandMode.variableColWidthVw
          ? this.currExpandMode.variableColWidthVw
          : this.variableColWidthVw

        if (this.tabType === 'startList') {
          // 出场名单
          let teamColWidth = 13.8
          if (
            ['SBD', 'LUG', 'BOB', 'DIV', 'FRS'].includes(
              this.currSportsDetail.sportsId
            ) &&
            ['D', 'T'].includes(this.competitorType)
          ) {
            variableColWidthVw = 55.5
          }
          defaultInsertCustomColuIndex = 2
          if (this.tableColumnData.length == 0) {
            let tableColumnData = []
            const customTeamColumn = {
              prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
              label: '国家/地区',
              widthVw: teamColWidth, //对应列的宽度，单位vw
              className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            }
            const customPlayerColumn = {
              prop: 'player_name', //fristColumnPropArr.join('-'),
              label: '运动员',
              widthVw: variableColWidthVw, //对应列的宽度，单位vw
              className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            }

            for (let i = 0; i < otherColumns.length; i++) {
              const item = otherColumns[i]
              tableColumnData.push({
                prop: item.colKey,
                label: item.colTitle,
                widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                  ? tableCellDefaultWidthVw / 2
                  : tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                  ? 'expandTdClassName'
                  : '', //单独定制的头部样式class
                selected: '',
              })
              if (i == 0) {
                tableColumnData.push(customTeamColumn)
                tableColumnData.push(customPlayerColumn)
              }
            }
            this.defaultWidthVwNum = tableColumnData.length - 4 //减去这4列[player_name, teamLogo-teamName, arrowIcon, isExpand]
            this.tableColumnData = tableColumnData
            console.debug('tableColumnData:', tableColumnData)
          }
          const rowHeightVw = 2.778, //第一行 行高 (只有奖牌榜medalTally用到这个字段，其他视图展开行的打开隐藏不需要计算这个值，它们的高度都是用内容撑出的高度)
            childRowHeightVw = 6.94, //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
            childRowHeightOtherVw = 0 //0.694是表格最下面的留白

          const childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
          this.tableData = data.data
            ? data.data.map((rowData) => {
                let currDataListRowNum = 0 //展开行有多高，取决于(上下半场)data.length个数
                if (rowData.row_detail && rowData.row_detail.length > 0) {
                  if (rowData.row_detail.length > currDataListRowNum) {
                    currDataListRowNum = rowData.row_detail.length
                  }
                }
                rowData.arrowIcon = ''
                if (this.isExpandAll) {
                  //是否全部展开
                  rowData.isShowChild = true
                } else {
                  rowData.isShowChild = false
                }

                rowData.row_detail = rowData.row_detail
                  ? rowData.row_detail
                  : []
                if (rowData.row_detail && rowData.row_detail.length > 0) {
                  rowData.isHasDetailData = true
                } else {
                  rowData.isShowChild = false //就是全部展开，如果没有子内容，展开无用，所以变为false
                  rowData.isHasDetailData = false
                }

                rowData.isExpand = {
                  renderMode: this.currSportsDetail.sportsId,
                  tabType: this.tabType,
                  defaultInsertCustomColuIndex,
                  rowHeightVw,
                  currHeightVw:
                    childRowBaseHeightVw +
                    currDataListRowNum * childRowHeightVw +
                    childRowHeightOtherVw,
                  list: rowData.row_detail,
                }
                return rowData
              })
            : []
        } else {
          // 本场数据

          if (this.tableColumnData.length == 0) {
            let tableColumnData = []
            let customTeamColumn = null

            if (
              ['LUG', 'BOB', 'DIV', 'FRS', 'SBD'].includes(
                this.currSportsDetail.sportsId
              ) &&
              this.competitorType !== 'T'
            ) {
              // DIV跳水没有团体，只有A和D，A和D一样本场数据
              // FRS 自由式滑雪 ADT都有，A和D同DIV；但T同游泳T，走默认模式
              // SBD 单板滑雪 只有A，A同DIV
              customTeamColumn = {
                prop: 'teamLogo-teamName-playerListString', //fristColumnPropArr.join('-'),
                label: '国家/地区',
                widthVw: this.currExpandMode.variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
              }
            } else {
              customTeamColumn = {
                prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
                label: '国家/地区',
                widthVw: variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
              }
            }
            console.debug('otherColumns', otherColumns)
            for (let i = 0; i < otherColumns.length; i++) {
              const item = otherColumns[i]
              tableColumnData.push({
                prop: item.colKey,
                label: item.colTitle,
                widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                  ? tableCellDefaultWidthVw / 2
                  : tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                  ? 'expandTdClassName'
                  : '', //单独定制的头部样式class
                selected: '',
              })
              if (i == defaultInsertCustomColuIndex) {
                tableColumnData.push(customTeamColumn)
              }
            }
            this.defaultWidthVwNum = tableColumnData.length - 3 //减去这2列[teamLogo-teamName, arrowIcon, isExpand]
            this.tableColumnData = tableColumnData
            console.debug('tableColumnData:', tableColumnData)
          }
          let rowHeightVw = 2.778, //第一行 行高
            childRowHeightVw = 6.94, //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
            childRowHeightOtherVw = 0 //0.694是表格最下面的留白

          let childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）

          // const originTableData = JSON.parse(JSON.stringify(this.tableData))
          this.tableData = data.data
            ? data.data.map((rowData) => {
                let currDataListRowNum = 0 //展开行有多高，取决于(上下半场)data.length个数
                if (
                  rowData.row_detail &&
                  rowData.row_detail.data &&
                  rowData.row_detail.data.length > 0
                ) {
                  rowData.isHasDetailData = true
                  if (rowData.row_detail.data.length > currDataListRowNum) {
                    currDataListRowNum = rowData.row_detail.data.length
                  }
                } else {
                  rowData.isShowChild = false //就是全部展开，如果没有子内容，展开无用，所以变为false
                  rowData.isHasDetailData = false
                }

                rowData.arrowIcon = ''
                if (this.isExpandAll) {
                  //是否全部展开
                  rowData.isShowChild = true
                } else {
                  // if(originTableData && originTableData.length>0 && originTableData[0]){
                  //   originTableData.forEach()
                  // }
                  rowData.isShowChild = false
                }

                rowData.row_detail = rowData.row_detail
                  ? rowData.row_detail
                  : {}

                let groupTitleObj = null
                if (
                  ['DIV', 'FRS', 'SBD'].includes(this.currSportsDetail.sportsId)
                ) {
                  if (
                    rowData.row_detail.table_head &&
                    rowData.row_detail.table_head.length > 0
                  ) {
                    let table_head = []
                    rowData.row_detail.table_head.forEach(
                      (headItem, headIndex) => {
                        if (headItem.name === '裁判分') {
                          groupTitleObj = {
                            width:
                              (rowData.row_detail.table_head.length - 1) *
                                5.55 +
                              headItem.map_key_arr.length * 3.47,
                            paddingLeft: headIndex * 5.55,
                            paddingRight:
                              (rowData.row_detail.table_head.length -
                                headIndex -
                                1) *
                              5.55,
                          }
                          headItem.map_key_arr.forEach((keyArr) => {
                            const arr = keyArr.split('_')
                            table_head.push({
                              name: arr[1],
                              map_key_arr: [keyArr],
                              className: 'groupItem',
                            })
                          })
                        } else {
                          table_head.push(headItem)
                        }
                      }
                    )
                    rowData.row_detail.table_head = table_head
                  }
                  if (this.currExpandMode.modeName === 'expandT_rowPlayers') {
                    rowHeightVw = 2.778 //第一行 行高
                    childRowHeightVw = 6.94 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                    childRowHeightOtherVw = 0 //0.694是表格最下面的留白

                    childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
                  } else {
                    rowHeightVw = 2.778 //第一行 行高
                    childRowHeightVw = 1.944 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                    childRowHeightOtherVw = 0 //0.694是表格最下面的留白

                    childRowBaseHeightVw = 3.332 + 1.944 //第一行展开行的基础高度（固定的高度）
                  }
                }

                let expandOtherList_head = []
                if (
                  this.currSportsDetail.sportsId === 'GAR' &&
                  this.tabType === 'teamResult'
                ) {
                  this.tableColumnData.forEach((column, colIndex) => {
                    if (colIndex > 1) {
                      expandOtherList_head.push(column)
                    }
                  })
                  expandOtherList_head = expandOtherList_head.splice(
                    0,
                    expandOtherList_head.length - 2
                  ) //删除掉箭头占位的2列

                  rowHeightVw = 2.778 //第一行 行高
                  childRowHeightVw = 6.94 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                  childRowHeightOtherVw = 0 //0.694是表格最下面的留白

                  childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
                }

                console.debug('expandOtherList_head:', expandOtherList_head)
                rowData.isExpand = {
                  renderMode: this.currSportsDetail.sportsId,
                  tabType: this.tabType,
                  expandModeName: this.currExpandMode
                    ? this.currExpandMode.modeName
                    : '',
                  defaultInsertCustomColuIndex,
                  rowHeightVw,
                  currHeightVw:
                    childRowBaseHeightVw +
                    currDataListRowNum * childRowHeightVw +
                    childRowHeightOtherVw,
                  list: rowData.row_detail,
                  groupTitleObj,
                  expandOtherList_head,
                }
                return rowData
              })
            : []
        }

        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
